import L from 'leaflet';
import mapbase from './map_base';
import util from '../util';
;
/**
 * 雨量地図表示用クラス
 */
export default class map_uryo extends mapbase {
    _isSp = false;
    _uryoCsv;
    _uryoConfig;
    _uryoLayer = null;
    _mapElement = "";
    /**
     * コンストラクタ
     */
    constructor(mapElement, mapPos, isSp) {
        super(mapElement, mapPos);
        this._isSp = isSp;
        this._mapElement = mapElement;
    }
    /**
     * 雨量レイヤを書き換える
     */
    checkUpdateLayer(updateTime) {
        if (!util.isSp) {
            this.setTimeLabel(updateTime);
        }
        this.dispUryoLayer(true);
        oldUpdatetimes.uinfo = updateTime;
    }
    /**
     * 雨量分布図の時刻ラベルの表示（PC版のみ）
     * @param value
     */
    setTimeLabel(value) {
        var year = (value.substr(0, 4));
        var month = (value.substr(4, 2));
        var day = (value.substr(6, 2));
        var hour = (value.substr(8, 2));
        var min = (value.substr(10, 2));
        var dt = new Date(parseInt(year), parseInt(month), parseInt(day), parseInt(hour), parseInt(min));
        //  １時間前の時間を計算
        var dtFrom = new Date(dt);
        dtFrom.setHours(dt.getHours() - 1);
        var hourFrom = ("0" + dtFrom.getHours()).slice(-2);
        var timelabel = dosya_1kmesh_env.label.uryo_datetime_label;
        var label = timelabel.replace("{year}", year)
            .replace("{month}", month)
            .replace("{day}", day)
            .replace("{hourFrom}", hourFrom)
            .replace("{hourTo}", hour)
            .replace("{minFrom}", min)
            .replace("{minTo}", min);
        $(`.${this._mapElement}.detail_uryo_timelabel`).text(label);
    }
    /**
     * 地図に雨量レイヤーを設定
     */
    dispUryoLayer(is60min) {
        const json = util.getGeoJson(util.getPath(dosya_1kmesh_env.uryoGeoJson));
        //  表示中のメッシュレイヤーが存在する場合は削除
        if (this._uryoLayer) {
            this.Map.removeLayer(this._uryoLayer);
        }
        //  雨量Configデータの取得
        this._uryoConfig = getCsv(config.uryoConfigUrl);
        //  雨量CSVデータの取得
        this._uryoCsv = getCsv(config.uinfoUrl);
        //  雨量レイヤ生成
        this._uryoLayer = this.createLayer(json, is60min);
        //  地図にメッシュレイヤー追加
        this.Map.addLayer(this._uryoLayer);
    }
    /**
     * 雨量レイヤの描画
     * @param json
     */
    createLayer(geoJson, is60min) {
        let self = this;
        return L.geoJSON(geoJson, {
            onEachFeature: (featureData, featureLayer) => {
                // 雨量ポイント押下時イベント
                featureLayer.on('click', () => {
                    self.onUryoPointClick(featureData.properties.code);
                });
                // ツールチップ設定（PC版のみ）
                if (!this._isSp) {
                    this.setToolTip(featureData, featureLayer, is60min);
                }
            },
            pointToLayer: (featureData, latlng) => {
                var ui = csvDef.uinfo;
                for (let i = ui.headerRow; i < this._uryoCsv.length - ui.footerRow; i++) {
                    var row = this._uryoCsv[i];
                    const uryoPoint = featureData.properties.code;
                    if (uryoPoint === row[ui.colCcd]) {
                        if (this._isSp && config.LabeledMakerZoomLevel <= self.Map.getZoom()) {
                            // ラベル付きマーカーを表示
                            return L.marker(latlng, {
                                icon: createLabeledMarker(getUryoIconUrl(parseInt(row[ui.colUryo60Min], 10), parseInt(row[ui.colUryo10Min], 10), is60min), getUryoPointName(this._uryoConfig, uryoPoint))
                            });
                        }
                        else {
                            return L.marker(latlng, { icon: L.icon({ iconUrl: getUryoIconUrl(row[ui.colUryo60Min], row[ui.colUryo10Min], is60min), iconSize: [15, 15] }) });
                        }
                    }
                }
                return L.marker(latlng);
            },
        });
    }
    /**
     * ツールチップの設定
     * @param featureData
     * @param featureLayer
     */
    setToolTip(featureData, featureLayer, is60min) {
        var tip = '';
        tip += getUryoPointName(this._uryoConfig, featureData.properties.code);
        var ui = csvDef.uinfo;
        for (let i = ui.headerRow; i < this._uryoCsv.length - ui.footerRow; i++) {
            let row = this._uryoCsv[i];
            if (featureData.properties.code == row[ui.colCcd]) {
                if (is60min) {
                    tip += '[ ' + row[ui.colUryo60Min] + 'mm/h]';
                    tip += '[ ' + dosya_1kmesh_env.label.ruiseki_uryo + ' ' + row[ui.colUryoRuiseki] + 'mm]';
                    break;
                }
                else {
                    tip += '[ ' + row[ui.colUryo10Min] + 'mm/10min]';
                    tip += '[ ' + dosya_1kmesh_env.label.ruiseki_uryo + ' ' + row[ui.colUryoRuiseki] + 'mm]';
                    break;
                }
            }
        }
        featureLayer.bindTooltip(tip, {
            offset: markerTooltipOffset,
            direction: 'top',
            sticky: true
        });
    }
    _preSelect = null;
    /**
     * マーカーのセット
     * @param latlng
     */
    setMaker(latlng) {
        if (latlng) {
            if (this._preSelect) {
                this._preSelect.remove();
            }
            this._preSelect = L.marker(latlng).addTo(this.Map);
            const markerEl = this._preSelect.getElement();
            if (markerEl) {
                markerEl.classList.add("current-location-pin-marker");
            }
        }
    }
    /**
     * 外部からの60分10分切替用関数
     */
    onChange60min10min(is60min) {
        this.dispUryoLayer(is60min);
    }
}
